import logo from './logo.svg';
import './App.css';
import {BoeingExperience, 
        MakabilityLabExperience, 
        HuskyRoboticsExperience,
        DIYDroneExperience} from './elements/ExperiencePanel';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Patrick Rungruengwatanachai</h1>
        <p>Professional silly guy</p>
      </header>
      <div>
        <h1>Experience: </h1>
        <BoeingExperience />
        <MakabilityLabExperience />
        <HuskyRoboticsExperience />
        <DIYDroneExperience />
      </div>
    </div>
  );
}

export default App;
